import { FC, useMemo } from 'react';

import { ChangeHistoryBannerFieldName, ChangeHistoryCampaignFieldName } from 'utils/constants/admin';

import { Text } from '@hh.ru/magritte-ui';
import { MinusOutlinedSize16, PlusOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import AgeRange from 'components/CampaignCard/CampaignInfo/Targetings/AgeRange/AgeRange';

import styles from 'components/common/ChangeHistoryModal/components/EventValue/EventValue.module.less';

export enum EventValueKind {
    Added = 'added',
    Removed = 'removed',
    New = 'new',
    Old = 'old',
}

const EVENT_ICONS = {
    [EventValueKind.Added]: <PlusOutlinedSize16 initialColor="secondary" />,
    [EventValueKind.Removed]: <MinusOutlinedSize16 initialColor="secondary" />,
    [EventValueKind.New]: null,
    [EventValueKind.Old]: null,
};

interface EventValueProps {
    fieldName: string;
    value: string;
    kind: EventValueKind;
}

export const EventValue: FC<EventValueProps> = ({ fieldName, value, kind }) => {
    const parsedAge = useMemo(() => {
        if (fieldName !== ChangeHistoryCampaignFieldName.Age) {
            return null;
        }
        try {
            return JSON.parse(value) as number[];
        } catch {
            return null;
        }
    }, [value, fieldName]);

    if (fieldName === ChangeHistoryBannerFieldName.Image) {
        return <img src={value} alt="" />;
    }

    if (value === '[]') {
        return null;
    }

    return (
        <div className={styles[kind]}>
            {EVENT_ICONS[kind]}
            <Text Element="span" typography="label-4-regular">
                {fieldName === ChangeHistoryCampaignFieldName.Age && parsedAge ? <AgeRange age={parsedAge} /> : value}
            </Text>
        </div>
    );
};
